import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerFetchTableType,
  triggerFetchOperationalDashboard,
  triggerFetchWorkFlow,
} from "../../redux/actions/operationalDashboard";
import { getTodaysDate } from "../../utils/common";
import OperationalDB from "../../views/operationalDashboard/index";
import Spinner from "../../components/presentationals/Spinner";
import CustomLandingBody from "../../components/customLandingBody";
import {
  triggerDashboardAudit,
  triggerIsDashboardAccessible,
} from "../../redux/actions";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";

const schemaName = ["PCREPORTS", "PASIMS"];

const OperationalDashboard = (props) => {
  const { getAllAPI, filterValue, tilesData } = useSelector(
    (state) => state.homeReducer
  );
  const { tableTypeObj, operationalDashObj, workFlowObj } = useSelector(
    (state) => state.operationalDashboardReducer
  );
  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  let defaultSelection = {
    dashboard: schemaName[0],
    tableType: "ALL",
  };

  const [selectedFormData, setSelectedFormData] = useState(defaultSelection);
  const [selectedDateFrom, setSelectedDateFrom] = useState(new Date());
  const [showAlert, setShowAlert] = useState(null);
  const [dashboardName, setDashboardName] = useState("Operational Dashboard");

  const dispatch = useDispatch();

  const updateDropValue = (dashName, value) => {
    setSelectedFormData({
      ...selectedFormData,
      [dashName]: value,
    });
  };

  const getDashName = (schemaName) => {
    if (schemaName.includes("PCREPORTS")) {
      return "Device Sales";
    } else {
      return "Recharge Sales";
    }
  };

  const fetchOperationalDashboard = (index) => {
    let obj = {};
    obj.headers = {
      endpoint: "/operational-dashboard-data",
      module: getDashName(selectedFormData.dashboard),
      "Content-Type": "application/json",
    };
    obj.param = {
      date: getTodaysDate(new Date(selectedDateFrom)),
    };

    dispatch(triggerFetchOperationalDashboard(obj, () => {}));
  };

  const fetchWorkFlowDetails = (index) => {
    let obj = {};
    obj.headers = {
      endpoint: "/operational-dashboardworkflow-list",
      module: selectedFormData.dashboard,
      "Content-Type": "application/json",
      subModule:
        index == 0
          ? "Device Payout"
          : index == 1
          ? "Recharge Payout"
          : "Activation Payout",
    };
    obj.param = {
      isRedisActive: "YES",
      module: selectedFormData.dashboard,
      roleType: tilesData?.data?.extraData?.role ?? "NHQ",
    };

    dispatch(triggerFetchWorkFlow(obj, () => {}));
  };

  // const fetchDataTable = () => {
  //   // param: obj.params,
  //   //   headers: obj.headers,
  //   let obj = {};
  //   obj.param = {
  //     isRedisActive: "NO",
  //     module: "",
  //     roleType: "NHQ",
  //   };
  //   obj.headers = {
  //     endpoint: "/operational-dashboardtabletype-list",
  //     module: selectedFormData.dashboard,
  //     "Content-Type": "application/json",
  //   };
  //   dispatch(
  //     triggerFetchTableType(obj, () => {
  //       fetchOperationalDashboard();
  //       fetchWorkFlowDetails();
  //     })
  //   );
  // };

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "run",
        dashboard: dashboardName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: "",
      },
    };
    triggerDashboardAudit(obj);
  };

  const onSubmit = () => {
    sendAudit();
    if (selectedFormData.dashboard == "My Earnings") {
      for (let i = 0; i < 3; i++) {
        fetchOperationalDashboard(i);
        // fetchWorkFlowDetails(i);
      }
    } else {
      fetchOperationalDashboard();
      // fetchWorkFlowDetails();
    }
  };

  useEffect(() => {
    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
        dispatch(triggerShowHeader(false));
        // fetchDataTable();
        fetchOperationalDashboard();
        // fetchWorkFlowDetails();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== ""
              ? filterValue.agentId
              : filterValue?.orgId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
              dispatch(triggerShowHeader(false));
              // fetchDataTable();
              fetchOperationalDashboard();
              // fetchWorkFlowDetails();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
      dispatch(triggerShowHeader(false));
      // fetchDataTable();
      fetchOperationalDashboard();
      // fetchWorkFlowDetails();
    }
  }, []);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <>
      <OperationalDB
        setSelectedDateFrom={setSelectedDateFrom}
        getTodaysDate={getTodaysDate}
        selectedDateFrom={selectedDateFrom}
        tilesData={tilesData}
        schemaName={schemaName}
        updateDropValue={updateDropValue}
        selectedFormData={selectedFormData}
        tableTypeObj={tableTypeObj}
        fetchOperationalDashboard={fetchOperationalDashboard}
        // fetchWorkFlowDetails={fetchWorkFlowDetails}
        onSubmit={onSubmit}
        triggerFetchTableType={triggerFetchTableType}
        triggerFetchWorkFlow={triggerFetchWorkFlow}
        triggerFetchOperationalDashboard={triggerFetchOperationalDashboard}
        isRedisActive={props.isRedisActive}
        getAllAPI={getAllAPI}
        operationalDashObj={operationalDashObj}
        workFlowObj={workFlowObj}
      />
    </>
  );
};
export default OperationalDashboard;
